import type { BannerMetaModel } from '@/apiClient/v1'
import type { UploadImageValues } from '@/commons/utils/imageUploadTypes'

export const buildInitialVenueImageValues = (
  bannerUrl?: string | null,
  bannerMeta?: BannerMetaModel | null
): UploadImageValues => {
  let cropParams:
    | {
        xCropPercent: number
        yCropPercent: number
        heightCropPercent: number
        widthCropPercent: number
      }
    | undefined

  if (bannerMeta !== undefined) {
    cropParams = {
      xCropPercent: bannerMeta?.crop_params?.x_crop_percent || 0,
      yCropPercent: bannerMeta?.crop_params?.y_crop_percent || 0,
      heightCropPercent: bannerMeta?.crop_params?.height_crop_percent || 0,
      widthCropPercent: bannerMeta?.crop_params?.width_crop_percent || 0,
    }
  }

  return {
    croppedImageUrl: bannerUrl || undefined,
    originalImageUrl: bannerMeta?.original_image_url || undefined,
    cropParams,
    credit: bannerMeta?.image_credit || '',
    alternativeText: bannerMeta?.image_alternative_text || '',
  }
}
